if (!customElements.get("nova-tabs")) {
  class NovaTabs extends HTMLElement {
    constructor() {
      super();

      // Tabs [START]
      this.tabs = this.querySelectorAll('[role="tab"]');
      this.prev = this.querySelector('[role="prev"]');
      this.next = this.querySelector('[role="next"]');

      // Add a click event handler to each tab
      this.tabs.forEach(tab => {
        tab.addEventListener("click", this.changeTabs.bind(this));
      });

      // Add a click event handler to next and previous buttons
      this.prev.addEventListener("click", this.prevTab.bind(this));
      this.next.addEventListener("click", this.nextTab.bind(this));
    }

    goToTab(target) {
      this.querySelectorAll('[aria-selected="true"]').forEach(t => t.setAttribute("aria-selected", false));

      // Set this tab as selected
      target.setAttribute("aria-selected", true);

      // Hide all tab panels
      this.querySelectorAll('[role="tabpanel"]').forEach(p => {
        // Remove first load classes (classes without animations)
        p.classList.contains("hidden") ? p.classList.remove("hidden") : null;
        p.classList.contains("active") ? p.classList.remove("active") : null;
        // Add animated classes (classes with animations)
        !p.classList.contains("tab-content--hidden") ? p.classList.add("tab-content--hidden") : null;
      });

      // Show the selected panel
      this.querySelector(`#${target.getAttribute("aria-controls")}`).classList.remove("tab-content--hidden");
    }

    changeTabs(e) {
      this.goToTab(e.currentTarget);
    }

    prevTab() {
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      let currentTab = tabs.find(p => p.getAttribute("aria-selected") == "true");

      const currentTabPos = Number(currentTab.id.split("-")[1]) - 1;

      const prevTab = currentTabPos - 1 < 0 ? tabs.length - 1 : currentTabPos - 1;

      this.goToTab(tabs[prevTab]);
    }

    nextTab() {
      const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      let currentTab = tabs.find(p => p.getAttribute("aria-selected") == "true");

      const currentTabPos = Number(currentTab.id.split("-")[1]) - 1;

      const nextTab = currentTabPos + 1 > tabs.length - 1 ? 0 : currentTabPos + 1;

      this.goToTab(tabs[nextTab]);
    }
  }

  customElements.define("nova-tabs", NovaTabs);
}
